const getUniqueValues = (data, key) => {
  return [
    ...new Set(
      data
        .flatMap((item) =>
          Array.isArray(item[key]) ? item[key] : [item[key]]
        )
        .filter(value => value !== '')
    ),
  ];
};

export default getUniqueValues;
